<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      FinancialAdjustmentsPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'FinancialAdjustmentsPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { title: this.$t('Common.financial') },
        { name: 'FinancialAdjustments', title: this.$t('Views.FinancialAdjustmentsPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
